module.exports = __webpack_public_path__ + "static/media/roble_apalache.3053f3e9.jpg";